// ─────────────────────────────────────────────────────────────────────────────
// main.tsx — Application entry point
//
// Sets up:
//  1. Redux store + PersistGate (prevents theme flash on load)
//  2. React Router for client-side navigation
//  3. Strict mode for catching potential issues in development
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { store, persistor } from '@/store';
import App from './App';
import 'flag-icons/css/flag-icons.min.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Redux Provider — makes the store available to all child components */}
    <Provider store={store}>
      {/* PersistGate — delays rendering until localStorage has been rehydrated.
          This prevents a flash of the default theme before the persisted theme loads.
          The loading prop can be a splash screen component if desired. */}
      <PersistGate loading={null} persistor={persistor}>
        {/* BrowserRouter — enables React Router's history API */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
